<script>
  import ScatterPlot from "./ScatterPlot.svelte";
  import LineChart from "./LineChart.svelte";
  import Benchmark from "./Benchmark.svelte";
  import {
    prepareScatterData,
    prepareLineData,
    prepareBenchmarkData,
    prepareMapData,
    prepareBarData,
    scatterToDownloadData,
    lineToDownloadData,
    benchmarkToDownloadData,
    mapToDownloadData,
    barToDownloadData,
  } from "./../utils/dataPrep";

  export let primaryCountry;
  export let countryData;

  let activeGroup = { value: "all", label: "All countries"}
  let highlightGroup = { value: "all", label: "All countries" };

  let xVariable = {
    value: "ngdpc_usd",
    label: "GDP per capita (current US$)",
  };
  let yVariable = {
    value: "life",
    label: "Life expectancy at birth, total (years)",
  };

  //Fetch scatterplot data
  let xData = [];
  let xLoading = true;
  $: fetch(`../data/variables/${xVariable.value}.json`)
    .then((res) => res.json())
    .then((data) => {
      xData = data;
      //bmData[0] = data;
      xLoading = false;
    })
    .catch((err) => console.error(err));

  let yData = [];
  let yLoading = true;
  $: fetch(`../data/variables/${yVariable.value}.json`)
    .then((res) => res.json())
    .then((data) => {
      yData = data;
      //bmData[1] = data;
      yLoading = false;
    })
    .catch((err) => console.error(err));

  $: scatterLoading = xLoading && yLoading;

  //Data prep
  let scatterData = [];
  $: scatterData = prepareScatterData(
    xData,
    yData,
    2018,
    countryData,
    activeGroup,
    true
  );

  $: if(scatterData.length > 0 && primaryCountry){
      primaryCountry.x = scatterData.find(cntr => cntr.label === primaryCountry.label).x;
      primaryCountry.y = scatterData.find(cntr => cntr.label === primaryCountry.label).y
    }
  $: lineData = prepareLineData(yData, countryData, activeGroup);
    

</script>

<ScatterPlot
  {scatterData}
  xAxisTitle={xVariable.label}
  xLog={false}
  yAxisTitle={yVariable.label}
  yLog={false}
  dotRadius={5}
  dotOpacity={0.7}
  dotColor={"#3f61da"}
  chartTitle={"Chart Title"}
  {highlightGroup}
  {primaryCountry}
  {xVariable}
  {yVariable}
  {scatterLoading}
  referenceCountries={null}
/>
<LineChart
        {lineData}
        xAxisTitle={"Year"}
        xLog={false}
        yAxisTitle={yVariable.label}
        yLog={false}
        dotRadius={0}
        dotOpacity={0}
        dotColor={"#3f61da"}
        chartTitle={"Chart Title"}
        {primaryCountry}
        referenceCountries={null}
        {highlightGroup}
        xVariable="Year"
        {yVariable}
        showDots={false}
      />
